import { RouteConfigProvider } from '@/context/route-config';
import FcaQuestionnaireForm, { type FcaQuestionnaireRouteConfig } from '@/features/onboarding/fca-questionnaire/components/form';
import FcaQuestionnaireLayout from '@/features/onboarding/fca-questionnaire/layout';
import { PERIODIC_REVIEW_PATHS } from '@/features/periodic-review/constants';

const ROUTE_CONFIG = {
  ineligible: PERIODIC_REVIEW_PATHS.FCA_QUESTIONNAIRE_INELIGIBLE,
  next: PERIODIC_REVIEW_PATHS.NATIONAL_CLIENT_IDENTIFIER,
  personalInformation: PERIODIC_REVIEW_PATHS.PERSONAL_INFORMATION,
} satisfies FcaQuestionnaireRouteConfig;

const PeriodicReviewFcaQuestionnairePage = () => {
  return (
    <FcaQuestionnaireLayout>
      <RouteConfigProvider config={ROUTE_CONFIG}>
        <FcaQuestionnaireForm />
      </RouteConfigProvider>
    </FcaQuestionnaireLayout>
  );
};
PeriodicReviewFcaQuestionnairePage.displayName = 'PeriodicReviewFcaQuestionnairePage';

export default PeriodicReviewFcaQuestionnairePage;
